<template>
  <div>
    <div v-for="(a, aIndex) in newList" :key="aIndex">
      <div class="page">
        <div
          v-for="(v, pindex) in page"
          :id="`Page2Pdf5Data${v}${aIndex}`"
          :key="pindex"
          class="pdf-box mb20"
        >
          <div>
            <div class="con-box">
              <MainTitle title="体能发育对比" :tag="a.title" />
              <div v-if="list.length" class="clearfix mt30">
                <template v-for="(item, index) in a.details">
                  <MiniTable2
                    v-if="(v === 1 && index < 24) || (v === 2 && index >= 24)"
                    :key="index"
                    :side-visible="false"
                    class="table"
                    :main-data="item"
                    head-bg="#f4f4f4"
                  />
                </template>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div
            v-for="(v, pindex) in page"
            :id="`Page2Pdf5Rank${v}${aIndex}`"
            :key="pindex"
            class="pdf-box mb20"
          >
            <div class="con-box">
              <MainTitle title="体能发育对比" :tag="a.title" />
              <div>
                <Rank :list="a" :page="v" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  groupCompareSynthEZAvgScore,
  getClassList
} from '@/api/teachingProtection/assessment'
import MainTitle from './MainTitle.vue'
import MiniTable2 from './MiniTable2.vue'
import Rank from './Rank.vue'

export default {
  components: {
    MiniTable2,
    MainTitle,
    Rank
  },
  props: {
    data: {},
    searchParams: {}
  },
  data() {
    return {
      frirstChartData: {},
      colorList: [],
      classroomName: '',
      sexName: '',
      ageName: '',
      mainArr: [],
      subArr: [],
      barDataArray: [],
      newList: [],
      list: [],
      page: 1
    }
  },
  created() {
    if (this.searchParams.classroomIds.length > 24) {
      this.page = 2
    }
    if (!this.searchParams) return
    let params = this.searchParams
    const classroomNames = []
    const sexNames = []
    const ageNames = []
    getClassList({
      periodType: params.periodType,
      year: params.year,
      semesterType: params.semesterType
    }).then((res) => {
      res.data.array.map((v) => {
        v.classrooms.map((q) => {
          if (params.classroomIds.indexOf(q.id) !== -1) {
            classroomNames.push(q.name)
          }
        })
      })
      this.classroomName = classroomNames.join('、')
    })
    this.$enums.gender.map((v) => {
      if (params.sexes.indexOf(v.code) !== -1) {
        sexNames.push(v.description)
      }
    })
    this.sexName = sexNames.join('、')

    groupCompareSynthEZAvgScore(params).then((res) => {
      this.list = res.data.barChart || []
      let list = this.$fn.deepClone(this.list)
      this.newList = list.map((q) => {
        return {
          details: q.details.map((item) => {
            item.values.pop()
            item.valueDescs.pop()
            return item
          }),
          remark: q.remark,
          title: q.title
        }
      })
      console.info(this.newList)
    })
  },
  methods: {
    getEle() {
      const arr = []
      this.newList.map((v, index) => {
        for (let i = 0; i < this.page; i++) {
          arr.push(document.getElementById(`Page2Pdf5Data${i + 1}${index}`))
        }
        for (let i = 0; i < this.page; i++) {
          arr.push(document.getElementById(`Page2Pdf5Rank${i + 1}${index}`))
        }
      })

      console.info(arr)

      return arr
    }
  }
}
</script>

<style lang="scss" scoped>
.table {
  float: left;
  width: 270px;
  margin-right: 7px;
  margin-bottom: 7px;
}
.pdf-box {
  width: 1200px;
  background: #ffffff;
  // transform: scale(0.9);
  // transform-origin: 0 0 0;
  .con-box {
    padding: 30px;
    min-height: 800px;
  }
}
.search-term {
  min-width: 100px;
}
.search-con {
  background: #f0f4f7;
  border-radius: 2px;
  padding: 5px 10px;
  max-width: 600px;
  margin-left: 20px;
  line-height: 20px;
}
.type-box {
  font-size: 12px;
  .name {
    font-weight: 500;
    font-size: 22px;
    color: #333333;
    line-height: 30px;
    text-align: left;
    font-style: normal;
  }
  .val {
    color: #ff6c14;
  }
}
.chart-item {
  float: left;
  width: 360px;
  height: 320px;
  margin-right: 20px;
  margin-bottom: 20px;
}
.tips {
  height: 51px;
  line-height: 51px;
  margin-right: 20px;

  .item {
    float: left;
    margin-right: 20px;
    position: relative;
    padding-left: 20px;
    i {
      position: absolute;
      content: "";
      left: 0px;
      top: 17px;
      height: 15px;
      width: 15px;
    }
  }
}
</style>
